import { ReactComponent as Logo } from '../../../img/directful-logo.svg'
import styles from './NotPhone.module.scss'
import { ReactComponent as PhoneIcon } from './phone.svg'

const NotPhone = () => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <Logo />
    </div>
    <div className={styles.container}>
      <PhoneIcon />
      <h1>Dashboard is optimized for big screens</h1>
      <p>Please visit the website on your PC or Mac for best experience.</p>
    </div>
  </div>
)

export default NotPhone
